import { render, staticRenderFns } from "./DownloadOrderFormPageButton.vue?vue&type=template&id=1fb746f8"
import script from "./DownloadOrderFormPageButton.vue?vue&type=script&lang=ts"
export * from "./DownloadOrderFormPageButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports